 
import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
    base: '#FF6100',
    darken1: colors.purple.darken2,
  },
  success: {
      base: '#FF6100',
      darken1: colors.purple.darken2,
  },
  'green-alert': {
    base: '#CCE1CD',
    darken1: colors.purple.darken2,
},
  umivalesecondary: '#B9CADD', 
  anchor: '#1976d2', 
  umivaletitle: '#124D91'
}